<template>
  <div style="width: 100%" v-if="currentSchool">
    <v-container class="px-md-8 py-md-5">
      <v-row class="justify-center">
        <v-col cols="12" sm="7">
          <v-row>
            <v-col>
              <v-card outlined>
                <v-container v-if="currentSchool.educational_fields">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="8" class="text-h6">Smjerovi</v-col>
                  </v-row>
                  <v-row v-if="currentSchool.educational_fields.length > 0">
                    <v-col>
                      <span
                          class="mr-2"
                          v-for="field in currentSchool.educational_fields"
                          :key="field.id"
                      >
                        <v-chip class="mb-2">{{ field.name }}</v-chip>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row v-else justify="center" class="text--disabled">
                    Nema smjerova.
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col
            cols="12"
            sm="3"
            v-if="
              $checkPermission('school_educational_field create')
          "
        >
          <v-btn
              v-if="$checkPermission('school_educational_field create')"
              block
              depressed
              height="44"
              class="primary text-none mb-4"
              @click="openDialog"
          >
            Ažuriraj smjerove
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog width="500" v-model="dialog" @click:outside="closeDialog">
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>Ažurirajte smjerova</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="closeDialog" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col>
                  <v-treeview
                      v-if="educationalFields"
                      :items="filteredEduFields"
                      open-on-click
                      ref="treeview"
                      selected-color="primary"
                      selection-type="independent"
                  >
                    <template slot="prepend" slot-scope="props">
                      <v-checkbox
                          dense
                          hide-details
                          v-if="!props.item.children"
                          v-model="props.item.selected"
                          @click="setSelected(props.item)"
                      >
                      </v-checkbox>
                    </template>
                  </v-treeview>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined height="44" class="text-none" @click="closeDialog"
          >Odustani</v-btn
          >
          <v-btn
              height="44"
              depressed
              class="primary text-none"
              @click="updateSchoolFields"
          >Potvrdi</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { serverBus } from "@/main";
import ApiV2 from "@/services/ApiV2";

export default {
  name: "Home",
  data() {
    return {
      educationalFields: null,
      selectedFields: [],
      dialog: false,
      form: {},
    };
  },
  computed: {
    currentSchool() {
      return this.$store.getters.getSchool;
    },
    filteredEduFields() {
      let data = this.educationalFields;

      if (this.currentSchool.type === "Osnovna škola") {
        return data.slice(0, 1);
      } else {
        return data.slice(1, 2);
      }
    },
  },
  created() {

    if (this.currentSchool) {
      this.getEducationalFields();
      this.selectExisting();
    } else {
      this.$router.push("/admin");
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$refs.treeview.updateAll();
      this.educationalFields = [];
      this.selectedFields = [];
    },

    openDialog() {
      this.getEducationalFields();
      this.selectExisting();
      this.dialog = true;
    },


    preselectFields(field) {
      this.selectedFields.forEach((selected) => {
        if (selected === field.id) {
          field.selected = true;
        }
      });

      if (field.children) {
        field.children.forEach((el) => {
          this.preselectFields(el);
        });
      }
    },

    setSelected(item) {
      const index = this.selectedFields.indexOf(item.id);
      if (index > -1) {
        this.selectedFields.splice(index, 1);
      }

      if (item.selected) {
        this.selectedFields.push(item.id);
      }
    },
    getEducationalFields() {
      ApiV2.get(`educational_fields`, {
        params: {
          "filter[parent_id]": "n=",
          with: "children",
        },
      }).then((response) => {
        this.educationalFields = response.data.data;

        this.educationalFields.forEach((field) => {
          this.preselectFields(field);
        });
      });
    },
    selectExisting() {
      this.selectedFields = this.currentSchool?.id
          ? this.currentSchool.educational_fields.map((el) => el.id)
          : [];
    },
    updateSchoolFields() {
      ApiV2.post(`schools/${this.currentSchool.id}/educationalFields`, {
        data: this.selectedFields,
        method: "sync",
      })
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch("getSchool");
              serverBus.$emit(
                  "show-snackbar",
                  true,
                  "Uspješno ste ažurirali smjerove."
              );
              this.closeDialog();
            }
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },
  },
  watch: {
    currentSchool: function(newVal) {
      this.optimizeData();
      this.selectExisting();
      this.getEducationalFields();
      if (!newVal) {
        this.$router.push("/admin");
      }
    },

  },
};
</script>
